var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveSession(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "live_session_icon_-_toggle",
    "data-name": "live session icon - toggle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10272",
    "data-name": "Path 10272",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1213",
    "data-name": "Ellipse 1213",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(5 5)",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10273",
    "data-name": "Path 10273",
    d: "M9,15c-2.67,0-8,1.34-8,4v1a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V19C17,16.34,11.67,15,9,15Zm6.47-7.23a3.272,3.272,0,0,1,0,2.46,1.242,1.242,0,0,0,.25,1.36l.03.03a1.223,1.223,0,0,0,1.95-.27,4.989,4.989,0,0,0-.02-4.66,1.234,1.234,0,0,0-1.97-.29l-.01.01a1.27,1.27,0,0,0-.23,1.36Zm3.71-4.88a1.142,1.142,0,0,0-.13,1.48,7.945,7.945,0,0,1-.03,9.25,1.14,1.14,0,0,0,.14,1.46l.03.03a1.167,1.167,0,0,0,1.74-.1,9.773,9.773,0,0,0,0-12.02,1.178,1.178,0,0,0-1.75-.1Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveSession);
export default __webpack_public_path__ + "static/media/live-session.73396e077b4ef5e52f7c43b22b70e39a.svg";
export { ForwardRef as ReactComponent };